import {
  TextField,
  NumberField,
  Edit,
  TextInput,
  useNotify,
  BooleanInput,
  EditBase,
  useRecordContext,
} from "react-admin";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import LocationEditForm from "./locationEdit";
import { errorHandlingFactory } from "../../ra-lb-tools/utils/errors";
import NotesModalField from "../../components/notesModalField";
import { MyList } from "../../ra-lb-tools/components/myList";
import { RecordTitle } from "../../ra-lb-tools/components/recordTitle";
import { UserField, UserInput } from "../users";
import { LinkButton } from "../../ra-lb-tools/components/linkButton";

export const LocationIcon = LocationOnIcon;

const LinkToRelatedTowers = ({ record }) => {
  record = record || useRecordContext();

  return record ? (
    <LinkButton
      color="primary"
      to={`/locations/${record.id}/show/towers`}
      label="Towers"
    />
  ) : null;
};

const locationFilters = () => [
  <TextInput source="id" alwaysOn key="id" />,
  <TextInput source="search" alwaysOn key={2} />,
  <BooleanInput
    source="exclude_retired_or_empty"
    alwaysOn
    key={3}
    format={(value) => !!value}
  />,
  <TextInput source="city" key={"city"} />,
  <TextInput source="state" key={"state"} />,
  <TextInput source="country" key={"country"} />,
  <TextInput source="name" key={1} />,
  <TextInput source="timezone" key="timezone" />,
  <UserInput source="tower__owner_id" key="tower__owner_id" />,
];

export const LocationList = (props) => (
  <MyList
    filters={locationFilters()}
    resource="locations"
    enableBulkCreate={true}
    {...props}
  >
    <TextField source="id" />
    <TextField source="name" />
    <TextField source="address1" />
    <TextField source="address2" />
    <TextField source="directions" />
    <NumberField source="lat" />
    <NumberField source="lon" />
    <TextField source="city" />
    <TextField source="state" />
    <TextField source="zip" />
    <TextField source="country" />
    <NotesModalField source="notes" />
    <UserField source="ownerId" />
    <TextField source="timezone" />
    <TextField source="doorAccessCode" />
    <LinkToRelatedTowers />
  </MyList>
);

export const LocationEdit = () => {
  const notify = useNotify();
  const onError = errorHandlingFactory(notify);

  return (
    <>
      <EditBase>
        <RecordTitle />
      </EditBase>

      <Edit mutationOptions={{ onError }}>
        <LocationEditForm />
      </Edit>
    </>
  );
};
